import cn from 'classnames';

import { IConDefaultType } from '..';

enum DiscoverIconVariant {
  DEFAULT = 'default',
}

interface IDiscoverIconProps extends IConDefaultType {
  variant?: DiscoverIconVariant;
}

function DiscoverIcon({
  color,
  className,
  size = 24,
  rotate,
  flip,
  variant = DiscoverIconVariant.DEFAULT,
}: IDiscoverIconProps) {
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        transform: `rotate(${rotate}deg)`,
      }}
    >
      {variant === DiscoverIconVariant.DEFAULT && (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none">
          <path
            d="M11.9994 5.93848L8.19766 7.675C7.99987 7.76541 7.76402 8.00119 7.67371 8.19895L5.93619 12.0007C5.52713 12.8955 6.44918 13.8176 7.344 13.4088L11.1458 11.6717C11.343 11.5815 11.5784 11.3457 11.6687 11.1484L13.4066 7.34662C13.8156 6.42324 12.8926 5.53008 11.9994 5.93848ZM10.4223 10.4242C10.0072 10.8393 9.33486 10.8393 8.91983 10.4242C8.50479 10.0092 8.50479 9.33682 8.91983 8.92178C9.33486 8.50674 10.0072 8.50674 10.4223 8.92178C10.8373 9.33848 10.8373 10.0092 10.4223 10.4242ZM9.67188 1.17383C4.97695 1.17383 1.17188 4.97891 1.17188 9.67383C1.17188 14.3687 4.97695 18.1738 9.67188 18.1738C14.3668 18.1738 18.1719 14.3687 18.1719 9.67383C18.1719 4.97891 14.3668 1.17383 9.67188 1.17383ZM9.67188 16.5801C5.86348 16.5801 2.76562 13.4819 2.76562 9.67383C2.76562 5.86576 5.86348 2.76758 9.67188 2.76758C13.4803 2.76758 16.5781 5.86576 16.5781 9.67383C16.5781 13.4819 13.4803 16.5801 9.67188 16.5801Z"
            fill={color}
          />
        </svg>
      )}
    </i>
  );
}

export default DiscoverIcon;
